import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function DifferenceDiagram(_props: DiagramProps) {
  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="Difference diagram">
      <defs>
        {/* Clip the hole out of the result rectangle */}
        <mask id="diff-mask">
          <rect x="0" y="0" width="280" height="150" fill="white" />
          {/* The hole: circle B shifted to result panel */}
          <circle cx={220} cy={82} r={22} fill="black" />
        </mask>
      </defs>

      {/* Panel: A (rectangle) */}
      <rect x={30} y={52} width={65} height={50}
            fill="rgba(96,165,250,0.18)" stroke={D.GEO_STROKE} strokeWidth="1.5" />
      <text x={62} y={44} fontSize="10" fontFamily="monospace"
            fill="currentColor" opacity="0.6" textAnchor="middle">A</text>

      {/* Panel: B (circle, overlapping area) */}
      <circle cx={82} cy={77} r={22}
              fill="rgba(239,68,68,0.2)" stroke="#ef4444" strokeWidth="1.5" />
      <text x={109} y={44} fontSize="10" fontFamily="monospace"
            fill="#ef4444" opacity="0.8" textAnchor="middle">B (subtracted)</text>

      {/* Minus sign */}
      <text x={113} y={83} fontSize="18" fontFamily="monospace"
            fill="currentColor" opacity="0.5" textAnchor="middle">−</text>
      <text x={130} y={83} fontSize="14" fontFamily="monospace"
            fill="currentColor" opacity="0.4" textAnchor="middle">=</text>

      {/* Result: A with hole where B was */}
      <rect x={158} y={52} width={65} height={50}
            fill="rgba(96,165,250,0.25)" stroke={D.GEO_STROKE} strokeWidth="1.5"
            mask="url(#diff-mask)" />
      {/* Hole outline */}
      <circle cx={220} cy={82} r={22}
              fill="none" stroke="#ef4444" strokeWidth="1" strokeDasharray="3 3" opacity="0.6" />

      <text x="140" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.4" textAnchor="middle">first child minus all others</text>
    </svg>
  );
}
